import * as React from 'react';
import { Table, CheckboxProps } from 'semantic-ui-react';
import { SprayEventId } from 'services/sprayEvents/types';
import RenderSubmissionSprayEventsTableRow from './components/RenderSubmissionSprayEventsTableRow';

interface Props {
    value?: SprayEventId[];
    onToggleTableRowCheckbox: (
        event: React.FormEvent<HTMLInputElement>,
        data: CheckboxProps
    ) => void;
    sprayEventIds?: SprayEventId[];
}

export default class RenderSubmissionSprayEventsTableRows extends React.PureComponent<
    Props
> {
    render(): React.ReactElement | React.ReactElement[] {
        const {
            value = [],
            sprayEventIds,
            onToggleTableRowCheckbox
        } = this.props;

        if (!sprayEventIds || !sprayEventIds.length) {
            return (
                <Table.Row colSpan="2" textAlign="center">
                    <Table.Cell
                        colSpan="2"
                        className="events-table-cell-padding"
                    >
                        No options.
                    </Table.Cell>
                </Table.Row>
            );
        }

        return sprayEventIds.map((id: SprayEventId) => (
            <RenderSubmissionSprayEventsTableRow
                key={id}
                sprayEventId={id}
                value={value}
                onToggleTableRowCheckbox={onToggleTableRowCheckbox}
            />
        ));
    }
}
